var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":"车辆日志","custom-class":"c-el-dialog comp-Vehicles-dialogLogs","visible":_vm.showDialog,"before-close":_vm._close},on:{"update:visible":function($event){_vm.showDialog=$event}}},[_c('logs',{ref:_vm.refVehiclesLogs})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }